module.exports = __webpack_public_path__ + "static/media/nf.fba00b75.svg";